import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import HiredLogo from "@/components/brand/HiredLogo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/auth/login", form);
      localStorage.setItem("hired_admin_token", data.token);
      localStorage.setItem("hired_token_kind", "admin");
      toast.success("Admin signed in");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-obsidian text-ivory flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-md">
        <Link to="/"><HiredLogo size={22} /></Link>
        <div className="brand-eyebrow mt-14 mb-4">ADMIN CONSOLE</div>
        <h1 className="brand-headline text-5xl mb-10">Internal <span className="italic text-purple">only.</span></h1>
        <div className="space-y-5">
          <div>
            <label>Email</label>
            <input data-testid="admin-email" type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
          </div>
          <div>
            <label>Password</label>
            <input data-testid="admin-password" type="password" required value={form.password} onChange={e => setForm({...form, password: e.target.value})} />
          </div>
        </div>
        <button data-testid="admin-login-btn" type="submit" disabled={busy} className="btn-gold w-full justify-center mt-8">
          {busy ? "Signing in…" : (<>Enter admin <ArrowRight size={16} /></>)}
        </button>
        <div className="mt-6 text-smoke text-xs">Separate credentials from customer accounts.</div>
      </form>
    </div>
  );
}
